import React, { Fragment, useState, useMemo } from "react";
import PageTitle from "../../layouts/PageTitle";
import ProjectSchedulerGrid from "./ProjectSchedulerGrid";
import ProjectListView from "./ProjectListView";
import AllocateResourceModal from "./AllocateResourceModal";
import { MOCK_RESOURCES, PROJECT_INFO } from "./mockProjectData";

function getMonday(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    const day = d.getDay();
    d.setDate(d.getDate() - day + (day === 0 ? -6 : 1));
    return d;
}

function fmt(date) {
    return date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });
}

const SELECT_STYLE = {
    paddingLeft: 32,
    paddingRight: 12,
    paddingTop: 7,
    paddingBottom: 7,
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    fontSize: 12,
    color: "#334155",
    background: "#fff",
    cursor: "pointer",
    outline: "none",
    fontWeight: 500,
    appearance: "none",
    WebkitAppearance: "none",
};

const ProjectView = () => {
    const [weekStart, setWeekStart] = useState(() => getMonday(new Date()));
    const [filterResource, setFilterResource] = useState("");
    const [searchText, setSearchText] = useState("");
    const [modalOpen, setModalOpen] = useState(false);

    const filteredResources = useMemo(() => {
        return MOCK_RESOURCES.filter((r) => {
            if (filterResource && r.name !== filterResource) return false;
            if (searchText) {
                const q = searchText.toLowerCase();
                if (
                    !r.name.toLowerCase().includes(q) &&
                    !r.role.toLowerCase().includes(q) &&
                    !r.department.toLowerCase().includes(q) &&
                    !r.task.toLowerCase().includes(q)
                )
                    return false;
            }
            return true;
        });
    }, [filterResource, searchText]);

    const handlePrev = () => {
        const d = new Date(weekStart);
        d.setDate(d.getDate() - 7);
        setWeekStart(d);
    };

    const handleNext = () => {
        const d = new Date(weekStart);
        d.setDate(d.getDate() + 7);
        setWeekStart(d);
    };

    const uniqueNames = MOCK_RESOURCES.map((r) => r.name);
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 4);

    return (
        <Fragment>




            {/* ── Controls bar ── */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 12,
                    background: "#fff",
                    borderRadius: 12,
                    padding: "14px 20px",
                    marginBottom: 16,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                    border: "1px solid #e2e8f0",
                }}
            >
                {/* Left: resource count + date range together */}
                <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>

                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <button
                            onClick={handlePrev}
                            style={{ width: 30, height: 30, borderRadius: "50%", border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#475569", fontSize: 12 }}
                            onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
                            onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                        >
                            <i className="fa fa-chevron-left" />
                        </button>
                        <i className="fa fa-calendar" style={{ color: "#94a3b8", fontSize: 13 }} />
                        <span style={{ fontSize: 14, fontWeight: 600, color: "#334155", whiteSpace: "nowrap" }}>
                            {fmt(weekStart)} – {fmt(weekEnd)}
                        </span>
                        <button
                            onClick={handleNext}
                            style={{ width: 30, height: 30, borderRadius: "50%", border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#475569", fontSize: 12 }}
                            onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
                            onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                        >
                            <i className="fa fa-chevron-right" />
                        </button>
                    </div>
                </div>
                {/* Right: resource filter */}
                <div style={{ position: "relative", display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                    <i
                        className="fa fa-user"
                        style={{
                            position: "absolute",
                            left: 10,
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#94a3b8",
                            fontSize: 11,
                            pointerEvents: "none",
                        }}
                    />
                    <select
                        value={filterResource}
                        onChange={(e) => setFilterResource(e.target.value)}
                        style={SELECT_STYLE}
                    >
                        <option value="">Select Resource</option>
                        {uniqueNames.map((n) => (
                            <option key={n} value={n}>{n}</option>
                        ))}
                    </select>
                    <i
                        className="fa fa-sliders"
                        style={{
                            position: "absolute",
                            right: 10,
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#94a3b8",
                            fontSize: 11,
                            pointerEvents: "none",
                        }}
                    />
                    <button
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 9,
                            background: "#f20037",
                            color: "#fff",
                            padding: "9px 18px",
                            borderRadius: 8,
                            fontSize: 13,
                            fontWeight: 700,
                            border: "none",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                            letterSpacing: "0.03em",
                        }}
                        onClick={() => setModalOpen(true)}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#f20037")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "#f20037")}
                    >
                        <i className="fa fa-plus" style={{ fontSize: 11 }} />
                        ALLOCATE RESOURCE
                    </button>
                </div>


            </div>

            {/* ── Scheduler grid with side arrows ── */}
            <div style={{ marginBottom: 28 }}>
                <ProjectSchedulerGrid
                    resources={filteredResources}
                    weekStart={weekStart}
                    onPrev={handlePrev}
                    onNext={handleNext}
                />
            </div>

            {/* ── List View ── */}
            <ProjectListView
                resources={filteredResources}
                weekStart={weekStart}
                onPrev={handlePrev}
                onNext={handleNext}
                filterResource={filterResource}
                onResourceChange={(v) => setFilterResource(v)}
            />
            <AllocateResourceModal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
            />
        </Fragment>
    );
};

export default ProjectView;
